module.exports = __webpack_public_path__ + "img/zhifushibai.dc6a4eb8.png";